import React from "react";
import { DefaultTFuncReturn, t } from "i18next";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomDatePickerInput from "../../customDatePickerInput/CustomDatePickerInput";
import i18n from "../../../i18n";
import  it  from "date-fns/locale/it"
import  enUS  from "date-fns/locale/en-US"


type Props = {
    label?: string | undefined | DefaultTFuncReturn;
    type?: string;
    placeholder?: string;
    value: string | Date | null;
    name: string;
    callbackOnChange: (e: any) => any;
    callbackOnFocus?: () => any;
    callbackOnBlur?: () => any;
    containerClass?: string;
    hasError?: boolean;
    errorMessage?: string;
    disabled?: boolean;
    isRequired?: boolean;
};

const InputText: React.FC<Props> = ({
    label = '',
    type = 'text',
    placeholder,
    value,
    name,
    callbackOnChange,
    callbackOnFocus,
    callbackOnBlur,
    containerClass,
    hasError = false,
    errorMessage,
    disabled = false,
    isRequired = false
}) => {

    const handleChange = (e: any) => {
        if (callbackOnChange) {
            callbackOnChange(e.target.value);
        }
    };

    const handleFocus = () => {
        if (callbackOnFocus) {
            callbackOnFocus();
        }
    };

    const handleBlur = () => {
        if (callbackOnBlur) {
            callbackOnBlur();
        }
    };

    const getLocaleForDatePicker = () => {
        switch (i18n.language) {
            case 'it':
                registerLocale("it", it);
                return 'it'
            case 'en':
            default:
                registerLocale("en", enUS);
                return 'en'
        }
    };


    return (
        <div className={containerClass}>
            {
                !!label &&
                <label className="font-semibold text-sm text-red uppercase leading-[17px] block mb-[5px]" htmlFor={name}>
                    {label}{isRequired ? ' *' : ''}
                </label>
            }

            {type === "date" ? (
                <DatePicker
                    locale={getLocaleForDatePicker()}
                    selected={value as Date | null}
                    onChange={(date: Date | null) => callbackOnChange(date)}
                    dateFormat="dd/MM/yyyy"
                    placeholderText={t('screens.profile.deteFormat') as string}
                    customInput={
                        <CustomDatePickerInput
                            error={hasError}
                        />
                    }
                    wrapperClassName="w-full"
                    className={"input-text leading-[18px] text-black text-[15px] bg-white border border-[#6F6F6F] rounded-[8px] p-[10px] w-full " + (hasError ? ' border-red' : '')}
                    popperPlacement="top-end"
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    disabled={disabled}
                    renderCustomHeader={({
                        date,
                        decreaseMonth,
                        increaseMonth,
                        prevMonthButtonDisabled,
                        nextMonthButtonDisabled,
                    }) => (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 10px" }}>
                            <button
                                onClick={decreaseMonth}
                                disabled={prevMonthButtonDisabled}
                                style={{ background: "none", border: "none", cursor: "pointer" }}
                            >
                                {"<"}
                            </button>
                            <span style={{ textTransform: "capitalize", fontWeight: 'bold' }}>
                                {date.toLocaleDateString(i18n.language, { month: "long", year: "numeric" })}
                            </span>
                            <button
                                onClick={increaseMonth}
                                disabled={nextMonthButtonDisabled}
                                style={{ background: "none", border: "none", cursor: "pointer" }}
                            >
                                {">"}
                            </button>
                        </div>
                    )}
                />
            ) : (
                <input
                    className={"input-text leading-[18px] text-black text-[15px] bg-white border border-[#6F6F6F] rounded-[8px] p-[10px] w-full" + (hasError ? ' border-red' : '')}
                    type={type}
                    placeholder={placeholder}
                    value={value as string}
                    name={name}
                    id={name}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    disabled={disabled}
                    required={isRequired}
                />
            )}

            {hasError && !!errorMessage && (
                <div className="text-xs text-red font-semibold mt-1">
                    {errorMessage}
                </div>
            )}
        </div>
    );
};

export default InputText;
